import { OrgUser, UserPermissions } from '@/types';

export const mockOrgUsers: OrgUser[] = [
    {
        id: 'ssullenberger@demo.com',
        email: 'ssullenberger@demo.com',
        firstName: 'Sully',
        lastName: 'Sullenberger',
        createdAt: '2022-03-21T19:38:42.521408018Z',
        groups: ['engineer', 'pilot', 'e3e915dc-ef2e-42f2-9311-820dcf060cc5'],
        permissions: [UserPermissions.Admin],
        uuid: '123-456-789',
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-sully.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-sully.png',
        },
        needsNewPassword: false,
    },
    {
        id: 'aearhart@demo.com',
        email: 'aearhart@demo.com',
        firstName: 'Amelia',
        lastName: 'Earhart',
        createdAt: '2021-11-10T22:52:11.509636074Z',
        groups: ['em', 'pilot', 'approver', 'e3e915dc-ef2e-42f2-9311-820dcf060cc5'],
        permissions: [],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
        uuid: 'abc-def-ghi',
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-amelia.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-amelia.png',
        },
        needsNewPassword: false,
    },
    {
        id: 'narmstrong@demo.com',
        email: 'narmstrong@demo.com',
        firstName: 'Neil',
        lastName: 'Armstrong',
        createdAt: '2021-05-21T13:17:19.283422229-04:00',
        groups: ['qa', 'pilot', 'e3e915dc-ef2e-42f2-9311-820dcf060cc4'],
        permissions: [],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
        uuid: 'abc-123-def-456',
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-neil.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-neil.png',
        },
        needsNewPassword: false,
    },
    {
        id: 'mjemison@demo.com',
        email: 'mjemison@demo.com',
        firstName: 'Mae',
        lastName: 'Jemison',
        createdAt: '2021-05-21T13:17:19.283422229-04:00',
        groups: ['cx', 'ops'],
        permissions: [],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
        uuid: 'abc-123-def-456',
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-mae.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-mae.png',
        },
        needsNewPassword: false,
    },
];
